export default __webpack_public_path__ + "static/media/interview_grey.eab04c53.svg";